export default {
    LOGIN: '/login',
    SEARCH_STATS: '/search',
    LEADS_STATS: '/leads',
    IMPRESSION_STATS: '/impression',
    COMPANY_STATS: '/company',
    COMPANY_REPORT: '/companyreport',
};
